package ar.corzo.health_tracker.connections

import ar.corzo.firebase.getDoc
import ar.corzo.health_tracker.types.Account

suspend fun getAccountByID(
    id: String
) = getDoc("users/$id")?.let{ Account.from(it, id) }